/**
 * Centralized Configuration File
 * All API URLs, site settings, and constants in one place
 * Change here and it will reflect everywhere
 */

const isBrowser = typeof window !== 'undefined';
const isLocalHost = isBrowser && ['localhost', '127.0.0.1'].includes(window.location.hostname);

const normalizeApiBaseURL = (value) => {
  if (!value) return value;
  const clean = value.trim().replace(/\/+$/, '');

  // Guard against accidental double /api prefix.
  if (clean.includes('/api/api/v1')) {
    return clean.replace('/api/api/v1', '/api/v1');
  }
  if (clean.endsWith('/api/v1')) return clean;
  if (clean.endsWith('/api')) return `${clean}/v1`;
  return `${clean}/api/v1`;
};

const defaultApiBaseURL = isLocalHost ? 'http://localhost:8000/api/v1' : '/api/v1';
const defaultServerURL = isLocalHost ? 'http://localhost:8000' : '';
const defaultSiteURL = isBrowser ? window.location.origin : 'http://localhost:3000';

const config = {
  // API Configuration
  api: {
    baseURL: normalizeApiBaseURL(process.env.REACT_APP_API_URL || defaultApiBaseURL),
    serverURL: process.env.REACT_APP_API_BASE_URL || defaultServerURL,
    timeout: 8000,  // 8s — fast fail for better UX
  },

  // Site Information
  site: {
    name: 'FK IT SOLUTION',
    tagline: 'Reliable IT Solutions',
    url: process.env.REACT_APP_SITE_URL || defaultSiteURL,
    logo: '/images/logo.png',
    favicon: '/favicon.png',
    foundedYear: 2017,
  },

  // Contact Information
  contact: {
    primaryPhone: '01973493174',
    secondaryPhone: '01712750459',
    whatsapp: '+880 1713-493174',  // Updated per client request
    supportEmail: 'info@fkitsolution.com',
    salesEmail: 'sales@fkitsolution.com',
    googleMap: 'https://maps.app.goo.gl/aPP2tYcgHLJF2VWr9',
  },

  // Office Addresses
  offices: {
    head: {
      label: 'Head Office',
      address: '292, Inner Circular Road, Shatabdi Center, 13th Floor, Fakirapool, Dhaka-1000',
      googleMap: 'https://maps.app.goo.gl/aPP2tYcgHLJF2VWr9',
    },
    corporate: {
      label: 'Corporate Office',
      address: 'Transparent Crown 220/A, 220/D, Begum Rokeya Sarani, West Kafrul, Dhaka-1216',
      googleMap: 'https://maps.app.goo.gl/aPP2tYcgHLJF2VWr9',
    },
  },

  // Social Media Links
  social: {
    facebook: 'https://www.facebook.com/fkitsolutionbd/',
    youtube: 'https://www.youtube.com/@FkItSolution',
  },

  // Services offered
  services: [
    'Laptop Sales',
    'Desktop / PC Build',
    'Computer Accessories',
    'Corporate / Bulk Sales',
    'Repair & Technical Support',
  ],

  // Payment Methods
  paymentMethods: {
    cash: 'We accept cash transactions on purchases from any of our outlets.',
    card: 'Credit / Debit Cards',
    bank: [
      { name: 'United Commerce Bank (UCB)', type: 'EFT / Internet Banking' },
      { name: 'City Bank (City Touch)', type: 'EFT / Internet Banking' },
    ],
    mobile: ['bKash', 'NOGOD'],
    cheque: 'Bank Cheque or Pay Order is accepted only after it is honored and fully deposited to FK IT Solution account.',
  },

  // API Endpoints (relative to baseURL)
  endpoints: {
    login: '/auth/login',
    register: '/auth/register',
    profile: '/auth/me',
    products: '/products/',
    productBySlug: (slug) => `/products/${slug}`,
    categories: '/categories/',
    categoryTree: '/categories/tree',
    categoryBySlug: (slug) => `/categories/${slug}`,
    banners: '/banners/',
    reviews: '/reviews/',
    productReviews: (productId) => `/reviews/product/${productId}`,
    messages: '/messages/',
    settings: '/settings/',
    admin: {
      products: '/products/admin',
      categories: '/categories/admin',
      banners: '/banners/admin',
      reviews: '/reviews/admin',
      messages: '/messages/admin',
      dashboard: '/admin/dashboard',
    },
  },

  // Default images
  images: {
    placeholder: '/placeholder.png',
    categoryPlaceholder: '/category-placeholder.png',
    userAvatar: '/user-avatar.png',
  },

  // Currency
  currency: {
    symbol: '৳',
    code: 'BDT',
    locale: 'bn-BD',
  },

  // Pagination defaults
  pagination: {
    defaultLimit: 12,
    maxLimit: 50,
  },
};

export default config;
